/**
 * {
    "id": "637a377de714538c8e7df7be",
    "title": "Test event",
    "description": "Description for test event",
    "image_url": "https://google.com",
    "start_date": 1668790808000,
    "end_date": 1668790657707
  },
 */

export type IEvent = {
    'id': string,
    'title': string,
    'active': boolean,
    'description': string,
    'image_url': string,
    'start_date': number,
    'end_date': number
}

export type IEventRequestPayload = Omit<IEvent, 'id'>;

export enum EVENT_ACTION_TYPE {    
    SELECT_EVENT = 'event/event-select',
    RESET_EVENT = 'event/reset-event',
    EVENT_LIST_UPDATE = 'user/event-list-update',

};

export type IEventState = {
    selected: IEvent | undefined,
    list: IEvent[]
};

function getInitialEventState(): IEventState {
    return {
        selected: undefined,
        list: []
    };
}

export function eventReducer(state = getInitialEventState(), action: {type: EVENT_ACTION_TYPE, payload: any}) {
    switch (action.type) {
        case EVENT_ACTION_TYPE.SELECT_EVENT:
            return {...state, selected: action.payload};
        case EVENT_ACTION_TYPE.RESET_EVENT:
                return {...state, selected: undefined};
        case EVENT_ACTION_TYPE.EVENT_LIST_UPDATE:
            return {...state, list: action.payload};
        default:
            return state;
    }
}